import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  isAppHost,
  isDomainSplitEnabled,
  isLandingAllowedPath,
  isLandingHost,
  isLandingPath,
  isReferralPath,
  redirectToApp,
  redirectToLanding,
} from '../utils/domainRouting';

export default function DomainRouteGuard({ children }) {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (!isDomainSplitEnabled()) {
      return;
    }

    if (isLandingHost() && !isLandingAllowedPath(pathname)) {
      redirectToApp(pathname, search, hash);
      return;
    }

    if (isAppHost() && isReferralPath(pathname)) {
      redirectToLanding(pathname, search, hash);
      return;
    }

    if (isAppHost() && isLandingPath(pathname)) {
      redirectToLanding(pathname, search, hash);
    }
  }, [pathname, search, hash]);

  if (!isDomainSplitEnabled()) {
    return children;
  }

  if (isLandingHost() && !isLandingAllowedPath(pathname)) {
    return null;
  }

  if (isAppHost() && isReferralPath(pathname)) {
    return null;
  }

  if (isAppHost() && isLandingPath(pathname)) {
    return null;
  }

  return children;
}
